import React from "react";

interface PolicyStudioZeroStateProps {
  isPublic: boolean;
}

export const PolicyStudioZeroState: React.FC<PolicyStudioZeroStateProps> = ({
  isPublic,
}) => {
  return (
    <div className="policy-sidebar-zero-state">
      <h2>No Policies</h2>
      <div className="policy-viewer-zero-text">
        {isPublic
          ? "Try out policy studio by creating a new policy with the + button or upload your own as a starting point"
          : "Create a new policy to get started"}
      </div>
    </div>
  );
};
